import { render, staticRenderFns } from "./ProjectGroupDetailsReports.vue?vue&type=template&id=7ae8563c&"
import script from "./ProjectGroupDetailsReports.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetailsReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports